import React, { useState, useEffect, useRef } from 'react';
import { LuBell, LuUser, LuLogOut, LuSettings, LuChevronDown, LuUsers, LuLayoutDashboard, LuFileText, LuBarChart3 } from "react-icons/lu";
import { Link, useNavigate } from 'react-router-dom';
import "../asset/css/admin-navbar.css";
import { BarChart3, DollarSign, Settings } from 'lucide-react'; 
import Swal from 'sweetalert2';

const Topbar = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const handleLogout = () => {
  Swal.fire({
    title: 'Logout',
    text: "Are you sure you want to log out?",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, logout!'
  }).then((result) => {
    if (result.isConfirmed) {
      // Remove the specific token
      localStorage.removeItem('adminToken');
      
      // Navigate to home/root
      navigate('/');
      
      // Optional: Success message
      Swal.fire({
        title: 'Logged Out!',
        text: 'You have been successfully logged out.',
        icon: 'success',
        timer: 1500,
        showConfirmButton: false
      });
    }
  });
};


  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (name) => {
    setActiveDropdown(activeDropdown === name ? null : name);
  };

  return (
    <header className="admin-header">
      {/* Brand Section */}
      <div className="admin-brand">
        <div className="admin-logo-box">A</div>
        <div className="admin-brand-info">
          <span className="admin-name">Measro <small>Admin</small></span>
          <span className="admin-status"><span className="status-dot"></span> System Online</span>
        </div>
      </div>

      {/* Main Navigation Menu */}
      <nav className="admin-nav-menu" ref={dropdownRef}>
        <Link to="/dashboard" className="nav-link active">
          <LuLayoutDashboard /> Dashboard
        </Link>

        {/* Users Menu */}
        <div className="nav-dropdown-wrapper">
          <button className="nav-link" onClick={() => toggleDropdown('users')}>
            <LuUsers /> Users <LuChevronDown className="arrow" />
          </button>
          {activeDropdown === 'users' && (
            <ul className="admin-submenu">
              <li><Link to="/all-users">All Customers</Link></li>
              {/* <li><Link to="/admin/users/roles">Roles & Permissions</Link></li> */}
              {/* <li><Link to="/admin/users/activity">Activity Logs</Link></li> */}
            </ul>
          )}
        </div>

        {/* Submissions Menu */}
        <div className="nav-dropdown-wrapper">
          <button className="nav-link" onClick={() => toggleDropdown('submissions')}>
            <LuFileText /> Submissions <LuChevronDown className="arrow" />
          </button>
          {activeDropdown === 'submissions' && (
            <ul className="admin-submenu">
              <li><Link to="/all-submission">All Submissions</Link></li>
              {/* <li><Link to="/admin/approved">Approved Projects</Link></li> */}
              {/* <li><Link to="/admin/rejected">Rejected</Link></li> */}
            </ul>
          )}
        </div>

{/* Settings Menu */}
<div className="nav-dropdown-wrapper">
          <button className="nav-link" onClick={() => toggleDropdown('settings')}>
            <Settings /> Settings <LuChevronDown className="arrow" />
          </button>
          {activeDropdown === 'settings' && (
            <ul className="admin-submenu">
              <li><Link to="/create-report">Create Features</Link></li>
              <li><Link to="/all-report">All Features</Link></li>
              <li><Link to="/coupons">Coupon</Link></li>
              <li><Link to="/faqs">FAQs</Link></li>
              <li><Link to="/feature-layer">Feature Layer</Link></li>

              


              {/* <li><Link to="/admin/rejected">Rejected</Link></li> */}
            </ul>
          )}
        </div>


        <Link to="/ticket" className="nav-link">
          <BarChart3 /> Ticket
        </Link>


        <Link to="/credits" className="nav-link">
          <DollarSign /> Credits
        </Link>



        <Link className="nav-link"  onClick={handleLogout}>
          <BarChart3 /> Logout
        </Link>



      </nav>

      {/* Right Side Actions */}
      <div className="admin-actions">
        {/* Notifications */}
      

        {/* Profile / Settings */}
        <div className="admin-profile-section" onClick={() => toggleDropdown('profile')}>
          <div className="admin-avatar">AD</div>
          <div className="admin-user-info d-none d-lg-block">
            <p className="admin-user-name">Admin Control</p>
            <p className="admin-user-role">Super Administrator</p>
          </div>
          
          {activeDropdown === 'profile' && (
            <ul className="admin-submenu profile-sub">
              <li><Link to="/admin/settings"><LuSettings size={14}/> Settings</Link></li>
              <li><Link to="/admin/notifications"><LuBell size={14}/> Notifications</Link></li>
              <li className="divider"></li>
              <li className="logout-item">
                <button onClick={handleLogout}>
                  <LuLogOut size={14}/> Logout
                </button>
              </li>
            </ul>
          )}
        </div>
      </div>
    </header>
  );
};

export default Topbar;